module.exports = __webpack_public_path__ + "static/media/Lunes.050d9b4f.jpg";